/* ==========================================================================
   Shop the Look - Tabs + Hotspots
   WOSP: Hotspots verlinken auf das jeweilige Produkt.
   Desktop: Hover zeigt die Produktkarte, Klick oeffnet die Produktseite.
   Touch:   Erster Tap zeigt die Produktkarte, zweiter Tap oeffnet das Produkt.
   ========================================================================== */

(function () {
  'use strict';

  function initShopTheLook(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-stl-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-stl-panel]'));
    var cardItems = Array.prototype.slice.call(section.querySelectorAll('[data-stl-product-card-item]'));

    if (!tabs.length || !panels.length) return;

    function cardFor(tabIndex, hotspotIndex) {
      for (var i = 0; i < cardItems.length; i++) {
        var item = cardItems[i];
        if (
          item.getAttribute('data-tab-index') === String(tabIndex) &&
          item.getAttribute('data-hotspot-index') === String(hotspotIndex)
        ) {
          return item;
        }
      }
      return null;
    }

    function showCard(tabIndex, hotspotIndex) {
      cardItems.forEach(function (item) {
        var matches =
          item.getAttribute('data-tab-index') === String(tabIndex) &&
          item.getAttribute('data-hotspot-index') === String(hotspotIndex);

        item.classList.toggle('is-active', matches);
        if (matches) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', '');
        }
      });
    }

    function setActiveHotspotWithinPanel(panel, hotspotToActivate) {
      var hotspots = panel.querySelectorAll('[data-stl-hotspot]');
      hotspots.forEach(function (hs) {
        hs.classList.toggle('is-active', hs === hotspotToActivate);
      });
    }

    function activatePanelDefaultHotspot(panel) {
      var firstHotspot = panel.querySelector('[data-stl-hotspot]');
      if (firstHotspot) {
        setActiveHotspotWithinPanel(panel, firstHotspot);
        showCard(
          firstHotspot.getAttribute('data-tab-index'),
          firstHotspot.getAttribute('data-hotspot-index')
        );
      }
    }

    function activateTab(index) {
      tabs.forEach(function (tab, i) {
        var isActive = i === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
          activatePanelDefaultHotspot(panel);
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = parseInt(tab.getAttribute('data-tab-index'), 10) || 0;
        activateTab(index);
      });
    });

    panels.forEach(function (panel) {
      var hotspots = panel.querySelectorAll('[data-stl-hotspot]');
      hotspots.forEach(function (hotspot) {
        if (hotspot.getAttribute('data-stl-bound') === '1') return;
        hotspot.setAttribute('data-stl-bound', '1');

        var tabIndex = hotspot.getAttribute('data-tab-index');
        var hsIndex = hotspot.getAttribute('data-hotspot-index');
        var card = cardFor(tabIndex, hsIndex);
        var links = card ? card.querySelectorAll('a[href*="/products/"]') : [];
        var url = links.length ? links[0].getAttribute('href') : null;

        if (url) {
          var label = '';
          for (var k = 0; k < links.length; k++) {
            var t = (links[k].textContent || '').replace(/\s+/g, ' ').trim();
            if (t) { label = t; break; }
          }
          hotspot.setAttribute('data-stl-url', url);
          hotspot.style.cursor = 'pointer';
          if (label) {
            hotspot.setAttribute('aria-label', label);
            hotspot.setAttribute('title', label);
          }
        }

        function preview() {
          setActiveHotspotWithinPanel(panel, hotspot);
          showCard(tabIndex, hsIndex);
        }

        hotspot.addEventListener('mouseenter', preview);
        hotspot.addEventListener('focus', preview);

        hotspot.addEventListener('click', function (event) {
          var target = hotspot.getAttribute('data-stl-url');
          if (target && hotspot.classList.contains('is-active')) {
            event.preventDefault();
            window.location.href = target;
            return;
          }
          preview();
        });

        hotspot.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          var target = hotspot.getAttribute('data-stl-url');
          if (target) {
            event.preventDefault();
            window.location.href = target;
          }
        });
      });
    });

    var activePanel = section.querySelector('[data-stl-panel].is-active') || panels[0];
    if (activePanel) activatePanelDefaultHotspot(activePanel);
  }

  function initAll() {
    var sections = document.querySelectorAll('.stl-section');
    sections.forEach(initShopTheLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.stl-section');
    if (section) initShopTheLook(section);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest('.stl-section');
    if (section) initShopTheLook(section);
  });
})();